import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';

function SingleBlogPage() {
  const { id } = useParams(); // Get the ID from the URL
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/healthblogs/${id}`)
      .then(res => {
        setBlog(res.data);
        setLoading(false);
      })
      .catch(err => {
        console.error("Error fetching blog:", err);
        setLoading(false);
      });
  }, [id]);

  if (loading) return <div className="text-center mt-5 pt-5"><h3>Loading article...</h3></div>;
  if (!blog) return <div className="text-center mt-5 pt-5"><h3>Blog post not found.</h3></div>;

  // Helper for image path
  const imageSrc = blog.image.startsWith('http') ? blog.image : `/images/health/${blog.image}`;

  return (
    <>
      {/* Header Image Section */}
      <div style={{
        backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url('${imageSrc}')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '400px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        marginTop: '60px'
      }}>
        <div className="container text-center">
          <span className="badge bg-primary mb-2">{blog.subtitle || 'Health Tips'}</span>
          <h1 className="display-4 fw-bold">{blog.title}</h1>
          <p className="lead">
            Published on {new Date(blog.date).toLocaleDateString()}
          </p>
        </div>
      </div>

      {/* Content Section */}
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-8">

            {/* Breadcrumb Back Link */}
            <Link to="/health" className="text-decoration-none text-secondary mb-4 d-block">
              <i className="bi bi-arrow-left me-2"></i> Back to Health Blog
            </Link>

            {/* Blog Content */}
            <div className="blog-content bg-white p-5 rounded shadow-sm" style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#444' }}>
              {/* We use white-space: pre-wrap to preserve paragraphs if it's plain text */}
              <p style={{ whiteSpace: 'pre-wrap' }}>
                {blog.description}
              </p>
            </div>

            {/* Author Section (Optional) */}
            <div className="mt-5 p-4 bg-light rounded border">
              <h5 className="fw-bold">About the Author</h5>
              <p className="mb-0 text-muted">
                This article was medically reviewed by D.Doctor specialists to ensure accuracy.
              </p>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}

export default SingleBlogPage;